import React, {useRef, useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {useDispatch} from "react-redux";
import ReactModal from 'react-modal';
import auth from "../../../utils/authentication";
import firebase from "../../../utils/firebase";
import {toast} from "react-toastify";
import {CustomModal} from "../../shared";

function ChangePassword({onClose}) {
    const intl = useIntl();
    const dispatch = useDispatch();

    const [currentPassword, setCurrentPassword] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [validCurrent, setValidCurrent] = useState("");
    const [validNew, setValidNew] = useState("");
    const [newPassError, setNewPassError] = useState("");
    const [validNewConf, setValidNewConf] = useState("");
    const closeModalButton = useRef(null);


    const saveNewPassword = () => {
        //validate passwords

        if(password !== confirmPassword){
            setValidNew("");
            setValidCurrent("");
            setValidNewConf("is-invalid");
            return;
        }
        setValidNewConf("");
        if(password.length < 6){
            setValidCurrent("");
            setValidNew("is-invalid");
            setNewPassError(intl.formatMessage({id: "users.signup.invalid-password"}));
            return;
        }
        if(password === currentPassword){
            setValidCurrent("");
            setValidNew("is-invalid");
            setNewPassError(intl.formatMessage({id: "profile.update-password.unchanged-password"}));
            return;
        }
        setValidNew("");

        const user = auth.currentUser;
        const credential = firebase.auth.EmailAuthProvider.credential(
            user.email,
            currentPassword
        );

        user.reauthenticateWithCredential(credential).then(r => user.updatePassword(password).then(
            () => {
                setCurrentPassword('');
                setPassword('');
                setConfirmPassword('');
                setValidCurrent("");
                onClose(true);
                closeModalButton.current.click();
                toast.success(intl.formatMessage({id: "profile.change-password.success"}));
            }
        )).catch(
            () => {
                setValidCurrent("is-invalid");
                setCurrentPassword('');
            }
        )
    }

    const closeModal = () => {
        setValidNew("");
        setValidCurrent("");
        setValidNewConf("");
        onClose(false);
        closeModalButton.current.click();
    }

    return (
            <CustomModal onClose={onClose} modalName="changePasswordModal" content={
                <div>
                    <button type="button" style={{display: 'none'}} data-bs-dismiss="modal"
                            aria-label="Close" ref={closeModalButton}></button>
                    <div className="modal-header d-flex flex-row flex-wrap justify-content-center" >
                        <h3 className="modal-title"><FormattedMessage id="profile.update-password"/></h3>
                        <button type="button" className="btn-close" onClick={closeModal}></button>
                    </div>
                    <div className="modal-body">
                        <div style={{textAlign: "center"}} className="text-muted mb-3">
                            <FormattedMessage id="profile.update-password.text"/>
                        </div>

                        <div className="form-floating mb-3 col-12">
                            <input id="currentPasswordInput" value={currentPassword} onChange={e => {
                                setCurrentPassword(e.target.value);
                            }} autoComplete="new-password"
                                   type="password" className={"form-control " + validCurrent}
                                   placeholder={intl.formatMessage({id: "profile.current-password"})}/>
                            <label htmlFor="userInput" ><FormattedMessage id="profile.current-password"/></label>
                            <div className="invalid-feedback">
                                <FormattedMessage id="users.login.bad-password"/>
                            </div>
                        </div>
                        <div className="form-floating mb-3 col-12">
                            <input id="passwordInput" value={password} onChange={e => {
                                setPassword(e.target.value);
                            }} autoComplete="new-password"
                                   type="password" className={"form-control " + validNew}
                                   placeholder={intl.formatMessage({id: "profile.new-password"})}/>
                            <label htmlFor="userInput"><FormattedMessage id="profile.new-password"/></label>
                            <div className="invalid-feedback">
                                {newPassError}
                            </div>
                        </div>
                        <div className="form-floating col-12">
                            <input id="confPasswordInput" value={confirmPassword} onChange={e => {
                                setConfirmPassword(e.target.value);
                            }} autoComplete="new-password"
                                   type="password" className={"form-control " + validNewConf}
                                   placeholder={intl.formatMessage({id: "profile.confirm-new-password"})}/>
                            <label htmlFor="userInput"><FormattedMessage id="profile.confirm-new-password"/></label>
                            <div className="invalid-feedback">
                                <FormattedMessage id="users.signup.password-unmatched"/>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={closeModal}>
                            <FormattedMessage id="modal.cancel"/>
                        </button>
                        <button type="button" className="btn btn-primary" onClick={saveNewPassword}>
                            <FormattedMessage id="profile.change-password.save"/>
                        </button>
                    </div>
                </div>
            }></CustomModal>
    )
}

export default ChangePassword;
